module.exports = __webpack_public_path__ + "static/media/report_market.10dd9394.svg";